import React, { useState, useEffect } from 'react';
import { useLazyQuery, useMutation, useQuery } from 'react-apollo';
import {
  TabContent,
  TabPane,
  Button,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { useToasts } from 'react-toast-notifications';
import LoadingOverlay from 'react-loading-overlay';
import {
  OFFER_TABS, ARTIST_OFFER_LIST_STATUS, NUMERIC_VALUE, loaderStyle,
} from '../../../utils';
import { OfferDetail } from '../../modals';
import DashboardActivities from './DashboardActivities';
import OfferCards from './OfferCards';
import { GET_OFFER_LIST_QUERY, GET_UNSEEN_MESSAGES, GET_ARTIST_NOTIFICATION } from '../../../graphql-client/queries';
import {
  REMOVE_OFFER_CLIENT, REMOVE_ARTIST_OFFER, UPDATE_REQUEST_STATUS, UPDATE_CONTRACT_ACCEPTED_STATUS,
  OFFER_NOTIFICATION_UPDATE_CLIENT,
} from '../../../graphql-client/mutations';
import Message from '../message/MessageContainer';
import PrivateOffers from './PrivateOffers';

function OfferBoard(props) {
  const {
    searchText, activeTab, artistId, filter, hasNotification, match, hash, gigTypeFilter, viewTypeFilter,
  } = props;
  const [offers, setOffers] = useState();
  const [currentPage, setCurrentPage] = useState(1);
  const [currentActiveTab, setCurrentActiveTab] = useState(null);
  const [currentActiveFilter, setCurrentActiveFilter] = useState(null);
  const [currentSearchText, setCurrentSearchText] = useState(null);
  const [apiData, setApiData] = useState(null);
  const [offerDetailModal, setOfferDetailModal] = useState(false);
  const [offerId, setOfferId] = useState({});
  const { addToast } = useToasts();
  const [getOffersQueryObj, setGetOfferQueryObj] = useState();
  const [paramsArtistId, setParamsArtistId] = useState();
  const { data: unSeenMessagesData } = useQuery(GET_UNSEEN_MESSAGES);
  const [messageModal, setMessageModal] = useState(false);
  const [messageModalObj, setMessageModalObj] = useState(false);
  const [refetchOfferDetail, setRefetchOfferDetail] = useState(false);
  const getActiveStatus = (tab) => {
    switch (tab) {
      case OFFER_TABS.ALL_OFFERS: return ARTIST_OFFER_LIST_STATUS.OFFER_BOARD;
      case OFFER_TABS.MY_OFFERS: return ARTIST_OFFER_LIST_STATUS.MY_OFFER;
      case OFFER_TABS.PRIVATE_OFFERS: return ARTIST_OFFER_LIST_STATUS.PRIVATE_OFFERS;
      case OFFER_TABS.AFFILIATE_OFFERS: return ARTIST_OFFER_LIST_STATUS.AFFILIATE_OFFERS;
      case OFFER_TABS.PASSED_OFFERS: return ARTIST_OFFER_LIST_STATUS.PASSED_OFFER;
      default: return null;
    }
  };
  const [
    getOffers, {
      data: offersData, refetch: refetchOffers, loading: getOffersLoading, fetchMore, client,
    },
  ] = useLazyQuery(GET_OFFER_LIST_QUERY, {
    fetchPolicy: 'network-only',
    variables: {},
  });
  const { data: notificationData } = useQuery(GET_ARTIST_NOTIFICATION, {
    variables: { artistId },
    pollInterval: 5000,
    // update: () => {
    //   console.log('----Update');
    //   // removeOfferClientMutation({ variables: apiData });
    // },
    // onCompleted: (data) => {
    //   console.log('----complete');
    //   // addToast(data.removeArtistOffer.message, { appearance: 'success' });
    // },
    // notifyOnNetworkStatusChange: () => {},
  });

  function reSetValue() {
    setRefetchOfferDetail(false);
  }

  const [removeOfferClientMutation] = useMutation(REMOVE_OFFER_CLIENT, {
    variables: {},
  });

  const [removeOfferMutation] = useMutation(REMOVE_ARTIST_OFFER, {
    variables: {},
    update: () => {
      removeOfferClientMutation({ variables: apiData });
    },
    onCompleted: (data) => {
      addToast(data.removeArtistOffer.message, { appearance: 'success' });
    },
  });

  const [offerNotificationUpdateClient] = useMutation(OFFER_NOTIFICATION_UPDATE_CLIENT);
  const [updateRequestStatusClient] = useMutation(UPDATE_REQUEST_STATUS);
  const [updateContractAcceptedStatusClient] = useMutation(UPDATE_CONTRACT_ACCEPTED_STATUS);

  /* ---- Get Private offer listing Query ----*/
  const { data: privateOffersData, loading: privateOffersLoading } = useQuery(GET_OFFER_LIST_QUERY,
    {
      fetchPolicy: 'network-only',
      variables: {
        status: ARTIST_OFFER_LIST_STATUS.FOR_ME, artistId, searchKey: searchText, gigType: [], viewType: [],
      },
    });

  const privateOfferList = privateOffersData && privateOffersData.offerList
    && privateOffersData.offerList.data;

  const toggleMessageModal = () => {
    setMessageModal(!messageModal);
    document.body.classList.add('messageModalOpen');
  };

  useEffect(() => {
    const id = new URLSearchParams(window.location.search).get('offerId');
    if (id && !offerDetailModal) {
      setOfferId({ offerId: id, segmentId: null });
      setOfferDetailModal(true);
    }
  }, []);

  useEffect(() => {
    if (searchText !== currentSearchText && refetchOffers) {
      setCurrentPage(1);
      setCurrentSearchText(searchText);
      setGetOfferQueryObj({
        page: 1,
        limit: NUMERIC_VALUE.TWENTY,
        searchKey: searchText,
        artistId,
        status: getActiveStatus(activeTab),
        gigType: gigTypeFilter,
        viewType: viewTypeFilter,
      });
    }
  }, [searchText]);

  useEffect(() => {
    if (hash) {
      const hashArr = hash.split('#');
      if (hashArr[1] === 'chat') {
        hashArr[2] && setMessageModalObj({ offerId: hashArr[2] });
        toggleMessageModal();
      }
    }
  }, [hash]);

  useEffect(() => {
    if (match && match.params.artistId && match.params.offerId) {
      const { params } = match;
      setOfferId({ offerId: params.offerId });
      setParamsArtistId(params.artistId);
      setOfferDetailModal(true);
    }
  }, [match && match.params]);

  useEffect(() => {
    if (filter && currentActiveFilter !== filter) {
      setCurrentActiveFilter(filter);
      setCurrentPage(1);
      setGetOfferQueryObj({
        page: 1, limit: NUMERIC_VALUE.TWENTY, searchKey: searchText, artistId, status: filter, gigType: gigTypeFilter, viewType: viewTypeFilter,
      });
    }
  }, [filter]);

  useEffect(() => {
    if ((activeTab && currentActiveTab && activeTab !== currentActiveTab) || artistId) {
      setCurrentActiveTab(activeTab);
      setGetOfferQueryObj(activeTab === '4' ? {
        status: ARTIST_OFFER_LIST_STATUS.FOR_ME, artistId, searchKey: searchText, gigType: [], viewType: [],
      } : {
        page: 1, limit: NUMERIC_VALUE.TWENTY, searchKey: searchText, artistId, status: getActiveStatus(activeTab), gigType: gigTypeFilter, viewType: viewTypeFilter,
      });
    }
  }, [activeTab, artistId]);

  useEffect(() => {
    if ((activeTab && currentActiveTab && activeTab !== currentActiveTab) || artistId) {
      setCurrentActiveFilter(filter);
      setCurrentPage(1);
      setGetOfferQueryObj({
        page: 1, limit: NUMERIC_VALUE.TWENTY, searchKey: searchText, artistId, status: getActiveStatus(activeTab), gigType: gigTypeFilter, viewType: viewTypeFilter,
      });
    }
  }, [gigTypeFilter]);

  useEffect(() => {
    offersData && offersData.offerList && setOffers(offersData.offerList.data);
  }, [offersData]);

  function refetchListing(params) {
    let refetch = false;
    if ((params?.publicHeaderNotification && activeTab === '1')
    || (params?.privateHeaderNotification && activeTab === '4')
    || (params?.affiliateHeaderNotification && activeTab === '5')
    || (params?.myOfferHeaderNotification && activeTab === '2')
    ) {
      refetch = true;
      setRefetchOfferDetail(true);
    }
    if (refetch) {
      getOffers({
        variables: {
          page: 1,
          limit: NUMERIC_VALUE.TWENTY,
          searchKey: searchText,
          artistId,
          status: getActiveStatus(activeTab),
          gigType: gigTypeFilter,
          viewType: viewTypeFilter,
        },
      });
    }
  }

  useEffect(() => {
    notificationData && hasNotification(notificationData.artistNotification);
    if (notificationData?.artistNotification) {
      refetchListing(notificationData?.artistNotification);
    }
  }, [notificationData]);

  const offerNotificationUpdate = () => {
    offerNotificationUpdateClient({
      variables: { ...offerId, apiData: getOffersQueryObj },
    });
  };

  useEffect(() => {
    getOffersQueryObj && getOffers({ variables: getOffersQueryObj });
  }, [getOffersQueryObj]);

  useEffect(() => {
    apiData && removeOfferMutation({ variables: { offerId: apiData.id, artistId } });
  }, [apiData]);

  const infiniteScroll = (page, limit) => {
    setCurrentPage(page);
    fetchMore({
      variables: {
        page, limit, searchText, artistId, status: filter,
      },
      updateQuery: (prev, { fetchMoreResult, variables }) => {
        if (!fetchMoreResult) return prev;
        const data = {
          ...prev,
          offerList: {
            data: [...prev.offerList.data, ...fetchMoreResult.offerList.data],
            count: fetchMoreResult.offerList.count,
            hasNextData: fetchMoreResult.offerList.hasNextData,
            __typename: fetchMoreResult.offerList.__typename,
          },
        };
        client.writeQuery({ query: GET_OFFER_LIST_QUERY, data, variables: { ...variables } });
        return data;
      },
    });
  };

  const toggleOfferDetailModal = () => {
    if (match && match.params.artistId && match.params.offerId) {
      window.location.href = `${window.location.origin}/dashboard${hash}`;
    }
    setOfferDetailModal(!offerDetailModal);
  };

  const openRequestModal = (id, segmentId = null) => {
    setOfferId({ offerId: id, segmentId });
    setOfferDetailModal(true);
  };

  const removeOffer = (id) => {
    setApiData({
      id,
      queryVars: getOffersQueryObj,
    });
  };

  const updateRequestStatus = (requested) => {
    updateRequestStatusClient({
      variables: {
        isRequested: requested,
        ...offerId,
        apiData: getOffersQueryObj,
      },
    });
  };

  const updateContractAcceptedStatus = (contractAccepted) => {
    updateContractAcceptedStatusClient({
      variables: {
        isContractAccepted: contractAccepted,
        ...offerId,
        apiData: {
          page: currentPage, limit: NUMERIC_VALUE.TWENTY, artistId, status: getActiveStatus(activeTab), searchKey: null, gigType: [], viewType: [],
        },
      },
    });
  };

  return (
    <>
      <div className="dashboard-content">
        {artistId && (
          <DashboardActivities
            artistId={artistId}
          />
        )}
        <TabContent activeTab={activeTab}>
          <LoadingOverlay
            active={getOffersLoading}
            spinner
            text=""
            className="dashboardContainerLoader"
            styles={loaderStyle}
          />
          <TabPane tabId={OFFER_TABS.ALL_OFFERS} className="dashboard-content-tab">
            {activeTab === OFFER_TABS.ALL_OFFERS && (
              <OfferCards
                offers={offers}
                hasNextData={offersData && offersData.offerList && offersData.offerList.hasNextData}
                handleInfiniteScroll={infiniteScroll}
                currentPage={currentPage}
                removeOffer={removeOffer}
                openModal={openRequestModal}
                status={OFFER_TABS.ALL_OFFERS}
                loading={getOffersLoading}
              />
            )}
          </TabPane>
          <TabPane tabId={OFFER_TABS.PRIVATE_OFFERS} className="dashboard-content-tab">
            {activeTab === OFFER_TABS.PRIVATE_OFFERS && (
              <PrivateOffers
                artistId={artistId}
                offers={privateOfferList}
                loading={privateOffersLoading}
              />
            )}
          </TabPane>
          <TabPane tabId={OFFER_TABS.MY_OFFERS} className="dashboard-content-tab">
            {activeTab === OFFER_TABS.MY_OFFERS && (
              <OfferCards
                offers={offers}
                hasNextData={offersData && offersData.offerList && offersData.offerList.hasNextData}
                handleInfiniteScroll={infiniteScroll}
                currentPage={currentPage}
                openModal={openRequestModal}
                status={OFFER_TABS.MY_OFFERS}
                loading={getOffersLoading}
              />
            )}
          </TabPane>
          <TabPane tabId={OFFER_TABS.AFFILIATE_OFFERS} className="dashboard-content-tab">
            {activeTab === OFFER_TABS.AFFILIATE_OFFERS && (
              <OfferCards
                offers={offers}
                hasNextData={offersData && offersData.offerList && offersData.offerList.hasNextData}
                handleInfiniteScroll={infiniteScroll}
                currentPage={currentPage}
                openModal={openRequestModal}
                status={OFFER_TABS.AFFILIATE_OFFERS}
                loading={getOffersLoading}
              />
            )}
          </TabPane>
          <TabPane tabId={OFFER_TABS.PASSED_OFFERS} className="dashboard-content-tab">
            {activeTab === OFFER_TABS.PASSED_OFFERS && (
              <OfferCards
                offers={offers}
                hasNextData={offersData && offersData.offerList && offersData.offerList.hasNextData}
                handleInfiniteScroll={infiniteScroll}
                currentPage={currentPage}
                openModal={openRequestModal}
                removeOffer={removeOffer}
                status={OFFER_TABS.PASSED_OFFERS}
                loading={getOffersLoading}
              />
            )}
          </TabPane>
        </TabContent>
        {offerDetailModal && (
          <OfferDetail
            isOpen={offerDetailModal}
            offerIdObj={offerId}
            onClose={() => { toggleOfferDetailModal(); }}
            artistId={artistId || paramsArtistId}
            updateRequestStatusClient={updateRequestStatus}
            updateContractAcceptedStatusClient={updateContractAcceptedStatus}
            offerNotificationUpdateClient={offerNotificationUpdate}
            activeTab={activeTab}
            refetchData={refetchOfferDetail}
            reSetValue={reSetValue}
          />
        )}

        {messageModal && (
          <Message
            isOpen={messageModal}
            onClose={toggleMessageModal}
            openOfferDetail={openRequestModal}
            offerId={messageModalObj && messageModalObj.offerId ? messageModalObj.offerId : null}
          />
        )}
      </div>

      <Button
        className={`${unSeenMessagesData && unSeenMessagesData.unseenMessages.find((el) => el.unseenMessage)
          ? 'notify' : ''}`}
        type="button"
        color="message"
        onClick={toggleMessageModal}
      >
        Message
      </Button>
    </>
  );
}
OfferBoard.propTypes = {
  searchText: PropTypes.string,
  activeTab: PropTypes.string,
  artistId: PropTypes.string.isRequired,
  filter: PropTypes.string,
  hasNotification: PropTypes.func.isRequired,
  match: PropTypes.shape({ params: { artistId: PropTypes.string, offerId: PropTypes.string, tabId: PropTypes.string } }),
  hash: PropTypes.string,
  gigTypeFilter: PropTypes.array,
  viewTypeFilter: PropTypes.array,
};

OfferBoard.defaultProps = {
  searchText: null,
  activeTab: OFFER_TABS.ALL_OFFERS,
  filter: ARTIST_OFFER_LIST_STATUS.ALL_OFFERS,
  match: null,
  hash: null,
  gigTypeFilter: [],
  viewTypeFilter: [],
};
export default OfferBoard;
